import React from 'react';

import AspectRatio from '@/components/common/AspectRatio';
import { getLocaleParkGuides } from '@/constants/parks';
import { trackEvent } from '@/services/track-event';

import css from './Parks.module.css';

const Parks = props => {
  const { locale } = props;

  const parksArray = getLocaleParkGuides(locale);

  if (!parksArray) return null;

  const trackLinkClicked = data => {
    trackEvent({
      event: 'Locality : Clicked carousel item',
      data,
    });
  };

  return (
    <ul className={css.parksList}>
      {parksArray.map(park => {
        const { link, image, name, count } = park;
        return (
          <li className={css.parkItem} key={name}>
            <AspectRatio ratio="3:4" hasImageHover="true" className="shadow100 hover:shadow200">
              <a
                title={name}
                href={link}
                onClick={() => trackLinkClicked({ typeOf: 'park', name, link })}>
                <img src={image} loading="lazy" alt={name} />
              </a>
            </AspectRatio>

            <h4 className="mt-2 text-lg bold">{name}</h4>
            <p className="text-gray-500">{`+${count} vehicles`}</p>
          </li>
        );
      })}
    </ul>
  );
};

export default Parks;
